// Sentry initialization must be imported first!
import './instrument';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register custom push notification service worker
if ('serviceWorker' in navigator) {
  console.log('🔧 [main.tsx] Service worker supported, will register on load');
  
  window.addEventListener('load', () => {
    console.log('🔧 [main.tsx] Page loaded, registering service worker...');
    
    navigator.serviceWorker
      .register('/sw-push.js', { scope: '/' })
      .then((registration) => {
        console.log('✅ [main.tsx] Push SW registered successfully');
        console.log('✅ [main.tsx] Scope:', registration.scope);
        console.log('✅ [main.tsx] State:', registration.active?.state);
        
        // Check if service worker is active
        if (registration.active) {
          console.log('✅ [main.tsx] Service worker is ACTIVE and ready for push');
        } else if (registration.installing) {
          console.log('⏳ [main.tsx] Service worker is INSTALLING');
        } else if (registration.waiting) {
          console.log('⏳ [main.tsx] Service worker is WAITING');
        }
        
        // Listen for service worker state changes
        if (registration.installing) {
          registration.installing.addEventListener('statechange', (e) => {
            console.log('🔧 [main.tsx] Service worker state changed to:', e.target.state);
          });
        }
      })
      .catch((error) => {
        console.error('❌ [main.tsx] Push SW registration failed:', error);
      });
  });
} else {
  console.warn('⚠️  [main.tsx] Service workers not supported in this browser');
} 